import React, { useState } from "react";
import { DialogActions } from "@material-ui/core";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  amountByPercent,
  formatDate,
  percentByAmount,
} from "../../../../utils/utils";
import { TabPanel, TabView } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import NumberFormat from "react-number-format";
import { useFormikContext } from "formik";

function SalesItemDiscount({
  discounts,
  property,
  openDiscount,
  setOpenDiscount,
  onSelectDiscount,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [expandedRows, setExpandedRows] = useState(null);
  const discountItemDetail = (rowData) => (
    <TabView className="tabview" scrollable>
      {rowData.minPurchaseType === 1 ? (
        <TabPanel header="Trigger Item">
          <table className="table">
            <thead>
              <tr>
                <th>Combination</th>
                <th>Req Fulfilled</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {rowData.discountTriggerItem.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Checkbox
                      style={{ marginRight: 5 }}
                      checked={item.combineFlag}
                      readOnly
                    />
                  </td>
                  <td>
                    {item.reqFulfilled ? (
                      <i
                        class="fa fa-check fa-2x kt-font-success"
                        aria-hidden="true"
                      />
                    ) : (
                      <i
                        class="fa fa-times fa-2x kt-font-danger"
                        aria-hidden="true"
                      />
                    )}
                  </td>
                  <td>{item.itemName}</td>
                  <td>{item.requireQty}</td>
                  <td>{item.uomName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabPanel>
      ) : null}
      {rowData.discountType === 1 ? (
        <TabPanel header="Amount Off Items">
          <table className="table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Unit</th>
                <th>Discount Percent</th>
                <th>Discount Value</th>
              </tr>
            </thead>
            <tbody>
              {rowData.discountAmountOffItem.map((item, index) => (
                <tr key={index}>
                  <td>{item.itemName}</td>
                  <td>{item.uomName}</td>
                  <td>
                    {item.discountAmountType === 1 ? item.discountPercent : 0}
                  </td>
                  <td>
                    <NumberFormat
                      value={
                        item.discountAmountType === 2 ? item.discountValue : 0
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      renderText={(value) => (
                        <div className="float-right">{value}</div>
                      )}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabPanel>
      ) : rowData.discountType === 2 ? (
        <TabPanel header="Free Items">
          <table className="table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {rowData.discountFreeItem.map((item, index) => (
                <tr key={index}>
                  <td>{item.itemName}</td>
                  <td>{item.qty}</td>
                  <td>{item.uomName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabPanel>
      ) : null}
    </TabView>
  );
  return (
    <DialogLayout
      open={openDiscount}
      title="Discounts Available"
      onCloseDialog={() => {
        setOpenDiscount(false);
      }}
      maxWIdth="lg"
    >
      <DataTable
        dataKey="ID"
        value={discounts}
        responsiveLayout="scroll"
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={discountItemDetail}
        selectionMode="single"
        onSelectionChange={(e) => {
          selectDiscount(e.value);
          onSelectDiscount(e.value);
        }}
      >
        <Column expander />
        <Column field="ID" header="ID" sortable />
        <Column
          field="reqFulfilled"
          header="Req Fulfilled"
          sortable
          body={(rowData) => (
            <>
              {rowData.reqFulfilled ? (
                <i
                  class="fa fa-check fa-2x kt-font-success"
                  aria-hidden="true"
                />
              ) : (
                <i
                  class="fa fa-times fa-2x kt-font-danger"
                  aria-hidden="true"
                />
              )}
            </>
          )}
        />
        <Column field="discountTypeName" header="Discount Type" sortable />
        <Column
          field="minPurchaseTypeName"
          header="Min Purchase Type"
          sortable
        />
        <Column field="discountName" header="Discount Name" sortable />
        <Column
          field="minPurchaseAmount"
          header="Min Purchase Amount"
          body={(rowData) => (
            <NumberFormat
              value={rowData.minPurchaseAmount}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => <div className="float-right">{value}</div>}
            />
          )}
          sortable
        />
        <Column
          field="startDate"
          body={(rowData) => formatDate(rowData.startDate)}
          header="Start Date"
          sortable
        />
        <Column
          field="endDate"
          body={(rowData) => formatDate(rowData.endDate)}
          header="End Date"
          sortable
        />
        <Column field="discountPercent" header="Disc %" sortable />
        <Column
          field="discountValue"
          header="Disc Value"
          body={(rowData) => (
            <NumberFormat
              value={
                rowData.discountAmountType === 1
                  ? rowData.discountPercent
                  : rowData.discountValue
              }
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => <div className="float-right">{value}</div>}
            />
          )}
          sortable
        />
      </DataTable>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            setOpenDiscount(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </DialogLayout>
  );

  function selectDiscount(
    discount = {
      ID: 0,
      discountName: "",
      discountType: 0,
      minPurchaseType: 0,
      discountAmountType: 1,
      discountPercent: 0,
      discountValue: 0,
    }
  ) {
    if (!discount.reqFulfilled) {
      return;
    }

    const salesItem = [...values[property]];
    if (discount.discountType === 1) {
      let subTotal = 0;
      let grandTotal = 0;
      for (const item of salesItem) {
        subTotal += item.totalPrice;
      }
      setFieldValue("subTotal", subTotal);
      if (discount.discountAmountType === 1) {
        const discountValue = amountByPercent(
          discount.discountPercent,
          subTotal
        );
        setFieldValue("discountPercent", discount.discountPercent);
        setFieldValue("discountAmount", discountValue);
      } else if (discount.discountAmountType === 2) {
        if (values.exchangeRate > 1) {
          discount.discountValue = discount.discountValue * values.exchangeRate;
        }

        const discountPercent = percentByAmount(
          discount.discountValue,
          subTotal
        );
        setFieldValue("discountAmount", discount.discountValue);
        setFieldValue("discountPercent", discountPercent);
      }
      grandTotal = subTotal - values.discountAmount + values.taxAmount;
      if (property === "salesPosItem") {
        setFieldValue("total", grandTotal);
      } else {
        setFieldValue("grandTotal", grandTotal);
      }
    } else if (discount.discountType === 2) {
      let itemFound = false;
      for (const freeItem of discount.discountFreeItem) {
        itemFound = false;
        for (const item of salesItem) {
          if (item.discountFreeItemID === freeItem.ID) {
            itemFound = true;
            break;
          }
        }
        if (itemFound) {
          continue;
        }
        salesItem.push({
          childItem: true,
          itemID: freeItem.itemID,
          varCode: freeItem.varCode,
          itemName: freeItem.itemName,
          itemPackageID: 0,
          itemPackageDetailID: 0,
          discountFreeItemID: freeItem.ID,
          discountAmountOffItemID: 0,
          qty: freeItem.qty,
          batchID: 0, //POS
          oriQty: freeItem.qty,
          currencyID: 0,
          oriMinimumPrice: 0,
          minimumPrice: 0,
          uomID: freeItem.uomID,
          uomName: freeItem.uomName,
          unitPrice: 0,
          discountAmountType: 1,
          discountPercent: 0,
          discountAmount: 0,
          taxPercent: 0,
          taxAmount: 0,
          totalPrice: 0,
          receiveType: 1, //POS
          editable: false,
          deleteInd: false,
        });
      }
    }
    setFieldValue("discountID", discount.ID);
    setFieldValue("discountName", discount.discountName);
    setFieldValue(property, salesItem);
    setOpenDiscount(false);
  }
}

export default SalesItemDiscount;
